import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useTeamRoleCardStyles = makeStyles({
  card: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[4]}`,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[3],
  },
  headerLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: designTokens.spacing[3],
    flex: "1 1 auto",
  },
  roleName: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
  assignedMemberWrapper: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  assignedValue: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
    cursor: "pointer",
    borderRadius: designTokens.borderRadius.sm,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
    border: `1px solid transparent`,
    ":hover": {
      border: `1px solid ${projectIqTokens.line}`,
      backgroundColor: projectIqTokens.bg2,
    },
  },
  assignedUnassigned: {
    color: projectIqTokens.faint,
    fontStyle: "italic",
  },
  assignedValueInput: {
    width: "200px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    flexShrink: "0",
  },
  chevronButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: designTokens.spacing[1],
    borderRadius: designTokens.borderRadius.sm,
    color: projectIqTokens.muted,
    display: "flex",
    alignItems: "center",
    ":hover": {
      backgroundColor: projectIqTokens.bg2,
      color: projectIqTokens.ink2,
    },
  },
  deleteButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: designTokens.spacing[1],
    borderRadius: designTokens.borderRadius.sm,
    color: projectIqTokens.muted,
    display: "flex",
    alignItems: "center",
    ":hover": {
      backgroundColor: "rgba(194,85,63,0.10)",
      color: projectIqTokens.rust,
    },
  },
  responsibilitiesSection: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },
  responsibilityList: {
    listStyle: "none",
    margin: "0",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  responsibilityItem: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  responsibilityBullet: {
    width: designTokens.spacing[2],
    height: designTokens.spacing[2],
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: projectIqTokens.teal,
    flexShrink: "0",
  },
  responsibilityText: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
    flex: "1 1 auto",
    cursor: "pointer",
    borderRadius: designTokens.borderRadius.sm,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[1]}`,
    ":hover": {
      backgroundColor: projectIqTokens.bg2,
    },
  },
  responsibilityItemInput: {
    flex: "1 1 auto",
  },
  addResponsibilityButton: {
    background: "none",
    border: `1px dashed ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
    cursor: "pointer",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.muted,
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    alignSelf: "flex-start",
    ":hover": {
      border: `1px dashed ${projectIqTokens.teal}`,
      color: projectIqTokens.tealInk,
    },
  },
});
